<!-- components/ArticleCard.vue -->
<script setup lang="ts">
import {useArticleStore} from "@/stores/articleStore";

defineProps<{
  page: any;
}>();

const articleStore = useArticleStore();

</script>

<template>
  <div class="flex flex-col gap-4 bg-transparent transition-transform transform md:hover:scale-[1.01] overflow-hidden group">

    <!-- Image -->
    <div class="relative block h-[250px] md:h-[290px]">
      <div class="overflow-hidden w-full h-full">
        <img
            :src="page.imageSet['760w']"
            :alt="page.title"
            class="w-full h-full object-cover duration-500 group-hover:scale-105"
        />
      </div>
    </div>


    <!-- Content -->
    <div class="flex flex-col h-full mt-3">
      <div class="flex flex-col gap-2 flex-1">
         <div
             class="responsive-body-xlarge text-primary-darkBlue font-semibold hover:underline cursor-pointer"
             @click = "$emit('on-visit-article', page.slug)"
         >
           {{ page.title }}
         </div>

        <span class="responsive-body-medium text-bw-midGrey ">
          {{ page.seoDescription }}
        </span>
      </div>
    </div>
  </div>
</template>


